module.exports = __webpack_public_path__ + "static/media/team_about_banner.8a91c96f.png";